export const DisabledFeatures = {
  TrendBaby: "TRENDBABY",
} as const

export const DISABLED_FEATURES_LABELS = {
  [DisabledFeatures.TrendBaby]: "TrendBaby",
}

export const DISABLED_FEATURE_OPTIONS: { label: string; value: string }[] = Object.entries(DISABLED_FEATURES_LABELS).map(
  ([value, label]) => ({ value, label }),
)
